import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;
const mono = "'IBM Plex Mono',monospace";
const grot = "'Space Grotesk',sans-serif";
const sans = "'IBM Plex Sans',sans-serif";

const inputStyle = { background: "#13161C", border: "1px solid #2B2F37", color: "#F2F4F6", borderRadius: 9, padding: "12px 16px", fontFamily: sans, fontSize: 14 };

const INTERESTS = [
  { id: "invest", label: "Invest", color: "#19C4C4" },
  { id: "operate", label: "Operate", color: "#3E8ED0" },
  { id: "pray", label: "Pray", color: "#C2613F" },
];

export default function ContactSection({ interest: interestProp }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [interest, setInterest] = useState("invest");
  const [sending, setSending] = useState(false);
  const [nlEmail, setNlEmail] = useState("");
  const [subscribing, setSubscribing] = useState(false);

  useEffect(() => {
    if (interestProp) setInterest(interestProp);
  }, [interestProp]);

  const submitLead = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) { toast.error("Please add your name and email."); return; }
    setSending(true);
    try {
      await axios.post(`${API}/api/leads`, { name: name.trim(), email: email.trim(), interest });
      toast.success("Thank you — we'll be in touch soon.");
      setName(""); setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally { setSending(false); }
  };

  const subscribe = async (e) => {
    e.preventDefault();
    if (!nlEmail.trim()) { toast.error("Please enter your email."); return; }
    setSubscribing(true);
    try {
      const res = await axios.post(`${API}/api/subscribe`, { email: nlEmail.trim() });
      toast.success(res.data.already_subscribed ? "You're already on the list." : "Subscribed — welcome to the work.");
      setNlEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally { setSubscribing(false); }
  };

  return (
    <div id="contact" style={{ borderTop: "1px solid #23262D" }} data-testid="contact-section">
      <div style={{ maxWidth: 880, margin: "0 auto", padding: "72px 24px", textAlign: "center" }}>
        <h2 style={{ fontFamily: grot, fontWeight: 600, letterSpacing: "-.02em", fontSize: "clamp(24px,3.4vw,32px)", margin: "0 0 14px", color: "#F2F4F6" }}>Let's talk.</h2>
        <div style={{ fontFamily: mono, fontSize: 14, color: "#9AA6B2", letterSpacing: ".04em" }}>[email] · [phone] · [location]</div>

        <form onSubmit={submitLead} style={{ margin: "36px auto 0", maxWidth: 560, textAlign: "left" }} data-testid="lead-form">
          <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap", marginBottom: 16 }}>
            {INTERESTS.map((it) => {
              const on = interest === it.id;
              return (
                <button type="button" key={it.id} data-testid={`interest-${it.id}-btn`} onClick={() => setInterest(it.id)} style={{ background: on ? "rgba(15,163,163,.14)" : "transparent", border: "1px solid " + (on ? it.color : "#2B2F37"), color: on ? it.color : "#9AA6B2", borderRadius: 999, padding: "7px 16px", fontSize: 13, cursor: "pointer", fontWeight: on ? 600 : 400, fontFamily: sans }}>{it.label}</button>
              );
            })}
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
            <input data-testid="lead-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" aria-label="Your name" style={{ ...inputStyle, flex: 1, minWidth: 180 }} />
            <input data-testid="lead-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" aria-label="Your email" style={{ ...inputStyle, flex: 1, minWidth: 200 }} />
            <button data-testid="lead-submit-btn" type="submit" disabled={sending} className="hv1" style={{ background: "#0FA3A3", color: "#fff", border: "none", fontWeight: 600, fontSize: 14, borderRadius: 9, padding: "12px 20px", cursor: "pointer", fontFamily: sans, opacity: sending ? 0.7 : 1 }}>
              {sending ? "Sending…" : "Start the conversation"}
            </button>
          </div>
        </form>

        <div style={{ marginTop: 40, paddingTop: 32, borderTop: "1px solid #23262D" }}>
          <p style={{ fontSize: 15, color: "#B6BFC9", fontWeight: 300, margin: "0 0 18px" }}>Follow the work. Updates from the field, the fund, and the founder.</p>
          <form onSubmit={subscribe} style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }} data-testid="newsletter-form">
            <input data-testid="newsletter-email-input" type="email" value={nlEmail} onChange={(e) => setNlEmail(e.target.value)} placeholder="you@example.com" aria-label="Email address" style={{ ...inputStyle, minWidth: 240 }} />
            <button data-testid="newsletter-subscribe-btn" type="submit" disabled={subscribing} className="hv1" style={{ background: "#0FA3A3", color: "#fff", border: "none", fontWeight: 600, fontSize: 14, borderRadius: 9, padding: "12px 20px", cursor: "pointer", fontFamily: sans, opacity: subscribing ? 0.7 : 1 }}>
              {subscribing ? "Subscribing…" : "Subscribe"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
